<template>
    <div class="sub-category">
        <div class="sub-category-item" v-for="(category, index) in categories" :key="index">
            <img :src="category.image" @click="goto(category)" />
        </div>
    </div>
</template>

<script>
export default {
  props: ['categoryType', 'categories'],
  methods: {
    goto (category) {
      const dest = category.route ? category.route : '/' + this.categoryType + '/' + category.id
      console.log('subcategory: ', category, dest)
      this.$router.push({path: dest})
    }
  }
}
</script>

<style scoped>
.sub-category {
    /* float: left; */
    width: 100%;
    height: 288px;
    display:flex;
    /* justify-content: space-around; */
    justify-content: center;
    margin-bottom: 30px;;
}
.sub-category-item {
    width: 100px;
    text-align: center;
    /* margin: 0 20px; */
    /* float: left; */
}
</style>



// WEBPACK FOOTER //
// src/components/templates/SubCategory.vue